function identityReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'STORE_IDENTIFICATION/IDCODE_CREATE':
    case 'STORE_PATIENT_IDENTIFICATION/VERIFY_CREATE':
    case 'STORE_PATIENT_IDENTIFICATION/ENROLL_CREATE':
      return action.result // What are the expected results?
    case 'CLEAR_IDENTITY':
      return null
    default:
      return state
  }
}

export default identityReducer
